import { Component, OnDestroy, OnInit } from "@angular/core";
import { ModalServiceService } from "src/app/_services/modal-service.service";
import { BsModalRef } from "ngx-bootstrap/modal";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { ReportService } from "../../../_services/report.service";
import { AgGridAngular } from "ag-grid-angular";
import {
 ColDef,
  IServerSideGetRowsParams,
} from "ag-grid-community";
import { UtilServiceService } from "src/app/_services/utilService/util-service.service";
import { TableHeaderToolTipComponent } from "src/app/shared/table-header-tool-tip/table-header-tool-tip.component";
import  moment from "moment-timezone";
import { AuthenticationService } from "src/app/auth/authentication.service";
import { PermissionService } from "src/app/auth/permission.service";
import { ButtonRendererComponent } from "src/app/renderer/button-renderer.component";
import { StatusRendererComponent } from "src/app/renderer/status-renderer.component";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from "rxjs";
import { DeleteRecordService } from "src/app/_services/delete-record.service";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { TitleCasePipe } from "@angular/common";

@Component({
  selector: "app-report-multiple-schedule",
  templateUrl: "./report-multiple-schedule.component.html",
  styleUrls: ["./report-multiple-schedule.component.scss"],
  standalone: false,
  providers: [TitleCasePipe]

})
export class ReportMultipleScheduleComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  data: any;
  isSchedulesFound: boolean= false;
  schedules: any = [];
  totalRecord: number = 0;
  columnDefs: any;
  defaultColDef: any;
  frameworkComponents: any;
  overlayNoRowsTemplate: any;
  gridOptions!:any;
  pageSize: any = 25;
  startFrom: any;
  actionData!: ColDef;
  gridParams: any;
  gridApi: any;
  scheduleList: any = [];
  deleteSubscription!: Subscription;
  dayList: any[] = [
    { name: "Monday", value: "MON" },
    { name: "Tuesday", value: "TUE" },
    { name: "Wednesday", value: "WED" },
    { name: "Thursday", value: "THU" },
    { name: "Friday", value: "FRI" },
    { name: "Saturday", value: "SAT" },
    { name: "Sunday", value: "SUN" },
  ]; //array to map for days value

  timeList: any[] = [
    { name: "7:00am", value: "07:00:00" },
    { name: "9:00am", value: "09:00:00" },
    { name: "12:00pm", value: "12:00:00" },
    { name: "5:00pm", value: "17:00:00" },
  ]; //array to map for time value

  constructor(
    private modalService: ModalServiceService,
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private reportServc: ReportService,
    private util: UtilServiceService,
    private auth: AuthenticationService, private titlePipe: TitleCasePipe,
    private perm: PermissionService,
    private router: Router, private spinner: NgxSpinnerService, private deleteRecordServc: DeleteRecordService) {
    super();
    this.preInit();
  }

  ngOnInit(): void {
    //this.init();
    this.languageTranslateService.wordSrc$.subscribe((transData) => {
      if (Object.keys(transData).length != 0) {
        this.translate = transData;
        this.getSchedulesByReportId();
      }
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onClickNew() {
    // Option A: close this list modal first (recommended to avoid stacked modals)
   // this.modalRef.hide(); // use your actual close method / ref
    this.data["mode"] = "add";
    // Then open the existing form modal
    let addModal: any = this.modalService.openModal("scheduleExportReport", this.data);
    addModal.onHide.subscribe((res: any) =>{
      if (res == 'addScheduleSuccess'){
        this.getSchedulesByReportId();
      }
    })
  }

  getSchedulesByReportId() {
    this.spinner.show();
    this.push(this.reportServc.getScheduleByReportId(this.data.id).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status == 200) {
          this.schedules = res.body;
          this.totalRecord = this.schedules.length;
          if (this.schedules.length == 0) {
            this.isSchedulesFound = false;
          } else {
            this.isSchedulesFound = true;
            this.initializeColumns();
          }
        }
      },
      (err: any) => {
        this.spinner.hide();
        console.log(err, "error gettting schedule by report id");
        if (err.error.detail == "scheduleNotFound") {
          this.isSchedulesFound = false;
        }
      }
    ));
  }

  private preInit() {
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent,
      statusRenderer: StatusRendererComponent,
    };

    this.gridOptions = {
      cacheBlockSize: 25,
      rowModelType: "clientSide",
      sortingOrder: ["desc", "asc"],
      onGridSizeChanged: (params:any) => {
        params.api.sizeColumnsToFit();
      },
      tooltipShowDelay: 100,
      pagination: true,
      paginationAutoPageSize: true,
    };

    this.defaultColDef = {
      enableRowGroup: true, //ag-Grid-Enterprise
      enablePivot: true, //ag-Grid-Enterprise
      enableValue: true, //ag-Grid-Enterprise
      sortable: true,
      resizable: true,
      filter: false,
      tooltipComponent: TableHeaderToolTipComponent,
    };
  }

  private initializeColumns() {
    this.defaultColDef = {
      enableRowGroup: true, //ag-Grid-Enterprise
      enablePivot: true, //ag-Grid-Enterprise
      enableValue: true, //ag-Grid-Enterprise
      sortable: true,
      resizable: true,
      filter: false,
      tooltipComponent: TableHeaderToolTipComponent,
    };

    this.overlayNoRowsTemplate =
      '<span style="padding: 10px; font-size: 14px;">' +
      this.translate?.general.messages.noRecordsFound +
      "</span>";

    this.actionData = {
      headerName: this.translate?.general.buttons.action.singular,
      filter: false,
      sortable: false,
      flex: 1,
      resizable: true,
      headerTooltip: "#",
      headerClass: "marging-auto hide-action-border",
      cellStyle: { "text-align": "center" },
      cellRenderer: "buttonRenderer",
      cellRendererParams: {
        onClick: this.edit.bind(this),
        permissions: { update: true, remove: true },
        /*hidden: {
          update: !this.perm.capable("job_order", "update"),
          remove: !this.perm.capable("job_order", "remove"),
        },*/
      },
    };

    const columns: ColDef[] = [
      {
        field: "fileType",
        headerName: this.translate?.report.fields.fileType.singular,
        hide: false,
        colId: "fileType",
        // filter: true,
        // sortable: true,
        flex: 1,
        resizable: true,
        cellClass: "text-1-5",
        headerTooltip: "#",
        cellRenderer: function (params: any) {
          if (params && params.value && params.value != undefined) {
            return params.value;
          } else {
            return "-";
          }
        },
      },
      {
        field: "startDate",
        headerName: this.translate?.report.fields.startDate.singular,
        hide: false,
        colId: "startDate",
        flex: 1,
        resizable: true,
        cellClass: "text-1-5",
        headerTooltip: "#",
        cellRenderer: function (params: any) {
          if (params && params.value && params.value != undefined) {
            let sDate: any = moment(params.value).format("DD/MM/YYYY hh:mm A");
            return sDate;
          } else {
            return "-";
          }
        },
      },
      {
        field: "endDate",
        headerName: this.translate?.report.fields.endDate.singular,
        hide: false,
        colId: "endDate",
        flex: 1,
        resizable: true,
        cellClass: "text-1-5",
        headerTooltip: "#",
        cellRenderer: function (params: any) {
          if (params && params.value && params.value != undefined) {
            let eDate: any = moment(params.value).format("DD/MM/YYYY hh:mm A");
            return eDate;
          } else {
            return "-";
          }
        },
      },
      {
        field: "frequency",
        headerName: this.translate?.report.fields.scheduleType.singular,
        hide: false,
        flex: 1,
        resizable: true,
        colId: "frequency",
        cellClass: "text-1-5",
        headerTooltip: "#",
        cellRenderer: (params: any) => {
          if (params && params.value && params.value != undefined) {
            return this.titlePipe.transform(params.value)
          } else {
            return "-";
          }
        }
      },
      {
        field: "weekPosition",
        headerName: this.translate?.report.fields.monthValue.singular,
        hide: false,
        flex: 1,
        resizable: true,
        colId: "weekPosition",
        cellClass: "text-1-5",
        headerTooltip: "#",
        cellRenderer:  (params: any) => {
          if (params && params.value && params.value != undefined) {
            return this.titlePipe.transform(params.value)
          } else {
            return "-";
          }
        }
      },
      {
        field: "weekDayOfMonth",
        headerName: this.translate?.report.fields.day.singular,
        hide: false,
        flex: 1,
        resizable: true,
        colId: "weekDayOfMonth",
        cellClass: "text-1-5",
        headerTooltip: "#",
        cellRenderer:  (params: any) => {
          if (params && params.value && params.value != undefined) {
            let val: any = params.value;
            let valueToDisplay: any = this.dayList.find((item: any) => {return item.value == val});
            return valueToDisplay.name;
          } else {
            if (params && params.data.dayOfWeek){
              let val: any = params.data.dayOfWeek;
              let valueToDisplay: any = this.dayList.find((item: any) => {return item.value == val});
              return valueToDisplay.name;
            }
            else{
              return "-";
            }
          }
        },
      },
      {
        field: "timeOfDay",
        headerName: this.translate?.report.fields.time.singular,
        flex: 1,
        resizable: true,
        hide: false,
        colId: "timeOfDay",
        cellClass: "text-1-5",
        headerTooltip: "#",
        cellRenderer: (params: any) => {
          if (params && params.value && params.value != undefined) {
            console.log(params, 'params printing...')
            console.log(this.timeList, 'timeList printing..');
            let val: any = params.value;
            let valueToDisplay: any = this.timeList.find((item: any) =>{return item.value == val});
            return valueToDisplay?.name;
          } else {
            return "-";
          }
        },
      },
    ];

    if (this.data.access !== 'VIEWER'){
      columns.push(this.actionData);
    }
    this.columnDefs = columns;
    this.onGridReady(this.gridParams);
  }

  private edit(e: any) {
    if (e.action === "edit") {
      let report: any = {
        id: e.rowData.id,
        mode: "edit",
        access: this.data.access,
      };
      let editModal: any = this.modalService.openModal("scheduleExportReport", report);
      editModal.onHide.subscribe(( res: any) =>{
        if (res == 'updateScheduleSuccess'){
          //refresh the table
          this.getSchedulesByReportId();
        }
      });
    } else if (e.action === "delete") {
      let message = "";
      if (e.rowData)
      { 
        message = this.translate?.report.messages.thisScheduleForThis + ' '+ this.translate?.report.label.singular+ ' '+ this.translate?.report.messages.willBeRemoved+'.'+ this.translate.general.messages.confirmProceed;
        // "The schedule for this report will be removed. Are you sure you want to proceed?";
      }

      const item = {
        deleteHeader: this.translate.general.buttons.delete.singular + ' ' + this.translate?.report.sections.sec11.singular + ' ' + this.translate.general.messages.confirmation,
        deleteType: "Report Schedule",
        id: e.rowData.id,
        message: message
      };

      if (!this.deleteSubscription) {
        this.deleteSubscription = this.deleteRecordServc
          .getItems(item)
          .pipe()
          .subscribe((data) => {
            // refresh the table
            this.getSchedulesByReportId();
            
          });
      } else {
        this.deleteRecordServc.getItems(item);
      }
    }
  }

  public onGridReady(params: any) {
    if (params) {
      this.gridParams = params;
      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();
      this.scheduleList = this.schedules;
      if (this.scheduleList.length == 0) {
        this.gridApi.hideOverlay();
      } else {
        this.gridApi.hideOverlay();
      }
    }
  }
 
}
